// extracted by mini-css-extract-plugin
export default {"FieldTypeInternalLink":"FieldTypeInternalLink--mwIL-"};